import { createSlice } from "@reduxjs/toolkit"

import { logout } from "../../LoginPage/redux/auth.actions"
import { REQUESTS_SLICE_NAME } from "./requests.constants"
import {
  deleteScreenshotsRequest,
  saveScreenshotsRequest,
  updateCommentRequest
} from "./requests.thunks"

/* ------------- Initial State ------------- */

const initialState = {
  saveFetching: false,
  saveResult: null,
  updateFetching: false,
  updateResult: null,
  deleteFetching: false,
  deleteResult: null,
  selectedRequest: null
}

const slice = createSlice({
  name: REQUESTS_SLICE_NAME,
  initialState,
  reducers: {
    // Legacy call sites dispatched this with two arguments - `requestsSetProp(key, value)`.
    // RTK actions carry a single payload, so callers pass `requestsSetProp({ key, value })`,
    // matching the `requestsAutoRefundSetProp`/`alertsSetProp` slices.
    requestsSetProp(state, action) {
      const { key, value } = action.payload
      state[key] = value
    }
  },
  extraReducers: (builder) => {
    builder
      /* ---------------- save screenshots ---------------- */
      .addCase(saveScreenshotsRequest.pending, (state) => {
        state.saveFetching = true
      })
      .addCase(saveScreenshotsRequest.fulfilled, (state) => {
        state.saveFetching = false
        state.saveResult = "add_screenshots"
      })
      .addCase(saveScreenshotsRequest.rejected, (state) => {
        state.saveFetching = false
      })

      /* ---------------- update comment ---------------- */
      .addCase(updateCommentRequest.pending, (state) => {
        state.updateFetching = true
      })
      .addCase(updateCommentRequest.fulfilled, (state, action) => {
        state.updateFetching = false
        state.updateResult = "update_comment"
        state.selectedRequest = { ...state.selectedRequest, ...action.payload }
      })
      .addCase(updateCommentRequest.rejected, (state) => {
        state.updateFetching = false
      })

      /* ---------------- delete screenshots ---------------- */
      .addCase(deleteScreenshotsRequest.pending, (state) => {
        state.deleteFetching = true
      })
      .addCase(deleteScreenshotsRequest.fulfilled, (state) => {
        state.deleteFetching = false
        state.deleteResult = "delete_screenshots"
      })
      .addCase(deleteScreenshotsRequest.rejected, (state) => {
        state.deleteFetching = false
      })

      /* ---------------- logout ---------------- */
      .addCase(logout, () => initialState)
  }
})

export const { requestsSetProp } = slice.actions

/* ------------- Selectors ------------- */

export const selectRequestResult = (state) =>
  state[REQUESTS_SLICE_NAME].saveResult ||
  state[REQUESTS_SLICE_NAME].updateResult ||
  state[REQUESTS_SLICE_NAME].deleteResult

export const reducer = slice.reducer
